import {NgModule} from "@angular/core";
import {SharedModule} from "../shared/shared.module";
import {InventorySearchPageComponent} from "./inventory/inventory-search-page/inventory-search-page.component";
import {SupplierMultiSelectSearchControlComponent} from "./supplier/controls/supplier-multi-select-search-control.component";
import {InventoryGroupSearchPageComponent} from "./inventory-group-search-page/inventory-group-search-page/inventory-group-search-page.component";
import {SupplierSearchPageComponent} from "./supplier/supplier-search-page/supplier-search-page.component";
import {ManufacturerSearchPageComponent} from "./manufacturer/manufacturer-search-page/manufacturer-search-page.component";
import {MeasureSearchPageComponent} from "./measure/measure-search-page/measure-search-page.component";
import {FrameworkModule} from "../framework/framework.module";
import {StockSharedModule} from "./stock.shared.module";
import {ManufacturerEditPageComponent} from "./manufacturer/manufacturer-edit-page/manufacturer-edit-page.component";
import {InventoryGroupEditPageComponent} from "./inventory-group-search-page/inventory-group-edit-page/inventory-group-edit-page.component";
import {SupplierEditPageComponent} from "./supplier/supplier-edit-page/supplier-edit-page.component";
import {AddressSharedModule} from "../address/address.shared.module";
import {MeasureEditPageComponent} from "./measure/measure-edit-page/measure-edit-page.component";
import {MeasureSingleSelectEditControlComponent} from "./measure/controls/measure-single-select-edit-control.component";
import {CustomObjectSharedModule} from "../custom-objects/custom-object.shared.module";
import {StockLevelSearchPageComponent} from "./stock-level/stock-level-search-page/stock-level-search-page.component";
import {PosSharedModule} from "../pos/pos.shared.module";
import {PurchaseOrderSearchPageComponent} from "./purchase-order/purchase-order-search-page/purchase-order-search-page.component";
import {ReceiveOrderSearchPageComponent} from "./receive-order/receive-order-search-page/receive-order-search-page.component";
import {CreditOrderSearchPageComponent} from "./credit-order/credit-order-search-page/credit-order-search-page.component";
import {CreditInvoiceSearchPageComponent} from "./credit-invoice/credit-invoice-search-page/credit-invoice-search-page.component";
import {SupplierInvoiceSearchPageComponent} from "./supplier-invoice/supplier-invoice-search-page/supplier-invoice-search-page.component";
import {StockTakeSearchPageComponent} from "./stock-take/stock-take-search-page/stock-take-search-page.component";
import {StockTransferSearchPageComponent} from "./stock-transfer/stock-transfer-search-page/stock-transfer-search-page.component";
import {InventoryEditPageComponent} from "./inventory/inventory-edit-page/inventory-edit-page.component";
import {InventoryEditDetailsComponent} from "./inventory/inventory-edit-page/inventory-edit-details/inventory-edit-details.component";
import {InventoryEditLocationComponent} from "./inventory/inventory-edit-page/inventory-edit-location/inventory-edit-location.component";
import {InventoryEditBarcodeComponent} from "./inventory/inventory-edit-page/inventory-edit-barcode/inventory-edit-barcode.component";
import {InventoryEditRecipeComponent} from "./inventory/inventory-edit-page/inventory-edit-recipe/inventory-edit-recipe.component";
import {SystemSharedModule} from "../system/system.shared.module";
import {InventoryRecipeSizeSingleSelectEditControlComponent} from "./inventory/controls/inventory-recipe-size-single-select-edit-control.component";
import {StockMovementAuditReportComponent} from "./reports/stock-movement-audit-report/stock-movement-audit-report.component";
import {StockMovementAuditOptionReportComponent} from "./reports/stock-movement-audit-report/stock-movement-audit-option-report/stock-movement-audit-option-report.component";
import {EmployeeSharedModule} from "../employee/employee.shared.module";
import {MeasureSingleSelectColumnComponent} from "./measure/controls/measure-single-select-column.component";
import {StockWastageReportComponent} from "./reports/stock-wastage-report/stock-wastage-report.component";
import {StockBatchValuationReportComponent} from "./reports/stock-batch-valuation-report/stock-batch-valuation-report.component";
import {StockInTransitReportComponent} from "./reports/stock-in-transit-report/stock-in-transit-report.component";
import {StockTransferReportComponent} from "./reports/stock-transfer-report/stock-transfer-report.component";
import {StockReplenishmentReportComponent} from "./reports/stock-replenishment-report/stock-replenishment-report.component";
import {StockUsageReportComponent} from "./reports/stock-usage-report/stock-usage-report.component";
import {StockValuationReportComponent} from "./reports/stock-valuation-report/stock-valuation-report.component";
import {UncountedStockReportComponent} from "./reports/uncounted-stock-report/uncounted-stock-report.component";
import {InventoryBarcodeSearchPageComponent} from "./inventory-barcode/inventory-barcode-search-page/inventory-barcode-search-page.component";
import {InventoryBarcodeReportComponent} from "./reports/inventory-barcode-report/inventory-barcode-report.component";
import {InvoiceSummaryReportComponent} from "./reports/invoice-summary-report/invoice-summary-report.component";
import {StockTakeReportComponent} from "./reports/stock-take-report/stock-take-report.component";
import {StockTakeExportSearchAction} from "./stock-take/controls/stock-take-export-search-action.component";
import {ReportsSharedModule} from "../reports/reports.shared.module";

@NgModule({
    imports: [
        SharedModule,
        FrameworkModule,
        ReportsSharedModule,
        CustomObjectSharedModule,
        StockSharedModule,
        AddressSharedModule,
        PosSharedModule,
        SystemSharedModule,
        EmployeeSharedModule
    ],
    declarations: [
        InventorySearchPageComponent,
        InventoryBarcodeSearchPageComponent,
        SupplierMultiSelectSearchControlComponent,
        InventoryGroupSearchPageComponent,
        InventoryGroupEditPageComponent,
        SupplierSearchPageComponent,
        ManufacturerSearchPageComponent,
        ManufacturerEditPageComponent,
        MeasureSearchPageComponent,
        SupplierEditPageComponent,
        MeasureEditPageComponent,
        MeasureSingleSelectEditControlComponent,
        StockLevelSearchPageComponent,
        PurchaseOrderSearchPageComponent,
        ReceiveOrderSearchPageComponent,
        CreditOrderSearchPageComponent,
        CreditInvoiceSearchPageComponent,
        SupplierInvoiceSearchPageComponent,
        StockTakeSearchPageComponent,
        StockTakeExportSearchAction,
        StockTransferSearchPageComponent,
        InventoryEditPageComponent,
        InventoryEditDetailsComponent,
        InventoryEditLocationComponent,
        InventoryEditBarcodeComponent,
        InventoryEditRecipeComponent,
        MeasureSingleSelectColumnComponent,
        InventoryRecipeSizeSingleSelectEditControlComponent,
        StockMovementAuditReportComponent,
        StockMovementAuditOptionReportComponent,
        StockWastageReportComponent,
        StockBatchValuationReportComponent,
        InventoryBarcodeReportComponent,
        StockInTransitReportComponent,
        StockTransferReportComponent,
        StockReplenishmentReportComponent,
        StockUsageReportComponent,
        StockValuationReportComponent,
        UncountedStockReportComponent,
        InvoiceSummaryReportComponent,
        StockTakeReportComponent
    ],
    exports: [
        InventorySearchPageComponent,
        InventoryBarcodeSearchPageComponent,
        SupplierMultiSelectSearchControlComponent,
        InventoryGroupSearchPageComponent,
        InventoryGroupEditPageComponent,
        SupplierSearchPageComponent,
        ManufacturerSearchPageComponent,
        ManufacturerEditPageComponent,
        MeasureSearchPageComponent,
        SupplierEditPageComponent,
        MeasureEditPageComponent,
        MeasureSingleSelectEditControlComponent,
        StockLevelSearchPageComponent,
        PurchaseOrderSearchPageComponent,
        ReceiveOrderSearchPageComponent,
        CreditOrderSearchPageComponent,
        CreditInvoiceSearchPageComponent,
        SupplierInvoiceSearchPageComponent,
        StockTakeSearchPageComponent,
        StockTakeExportSearchAction,
        StockTransferSearchPageComponent,
        InventoryEditPageComponent,
        InventoryEditDetailsComponent,
        InventoryEditLocationComponent,
        InventoryEditBarcodeComponent,
        InventoryEditRecipeComponent,
        MeasureSingleSelectColumnComponent,
        InventoryRecipeSizeSingleSelectEditControlComponent,
        StockMovementAuditReportComponent,
        StockMovementAuditOptionReportComponent,
        StockWastageReportComponent,
        StockBatchValuationReportComponent,
        InventoryBarcodeReportComponent,
        StockInTransitReportComponent,
        StockTransferReportComponent,
        StockReplenishmentReportComponent,
        StockUsageReportComponent,
        StockValuationReportComponent,
        UncountedStockReportComponent,
        InvoiceSummaryReportComponent,
        StockTakeReportComponent
    ]
})
export class StockModule {
}
